import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import axiosInstance from "../api/axiosInstance";
import { useSelector } from "react-redux";
import useSocketEvent from "../socket/useSocketEvent";
const WalletContext = createContext();
const WalletProvider = ({ children }) => {
  const { userInfo } = useSelector((state) => state.auth);
  const [walletAmt, setwalletAmt] = useState(null);
  const [adminWallet, setAdminWalletAmt] = useState(null);
  const userId = userInfo?._id;
  const refreshWalletCart = useCallback(async (id) => {
    const userIdToUse = id || userId;
    if (!userIdToUse) return;
    try {
      const response = await axiosInstance.get(`/api/wallet/${userIdToUse}`, {
        meta: { showLoader: false },
      });
      const result = {
        success: true,
        data: response?.data?.data?.wallet,
        message: response?.data?.message || "Successful",
      };
      if(result?.success){
          setwalletAmt(result.data);
          return result;
      }
    } catch (error) {
      const errResult = {
        success: false,
        message:
          error.response?.data?.message ||
          error.response?.data?.error ||
          "Failed. Please try again.",
        status: error.response?.status || 500,
      };
      return errResult;
    }
  }, [userId]);
   const refreshadminWallet = useCallback(async () => {
    const userIdToUse = userInfo?.role==='super_admin';
    if (!userIdToUse) return;
    try {
      const response = await axiosInstance.get(`/api/admin/bank/wallet`, {
        meta: { showLoader: false },
      });
      const result = {
        success: true,
        data: response?.data?.data?.wallet,
        message: response?.data?.message || "Successful",
      };
      if(result?.success){
          setAdminWalletAmt(result.data);
          return result;
      }
    } catch (error) {
      const errResult = {
        success: false,
        message:
          error.response?.data?.message ||
          error.response?.data?.error ||
          "Failed. Please try again.",
        status: error.response?.status || 500,
      };
      return errResult;
    }
  }, [userInfo?.role]);
  useEffect(() => {
    if (userId) refreshWalletCart(userId);
  }, [userId, refreshWalletCart]);
  useEffect(() => {
  refreshadminWallet()
  }, [refreshadminWallet]);
  const onWalletChanged = useCallback((payload) => {
    if (payload?.userId && userId && String(payload.userId) !== String(userId)) {
      const ids = payload?.userIds || [];
      if (!ids.map(String).includes(String(userId))) return;
    }
    refreshWalletCart();
  }, [refreshWalletCart, userId]);
  useSocketEvent("wallet_changed", onWalletChanged);
  return (
    <WalletContext.Provider value={{ walletAmt, refreshWalletCart,adminWallet,refreshadminWallet }}>
      {children}
    </WalletContext.Provider>
  );
};
const useWallet = () => {
  return useContext(WalletContext);
};
export { WalletProvider, useWallet };
